import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import ReactGallery from 'react-photo-gallery';
import SelectedImage from './SelectedImage';
import toastr from 'toastr';


export default class ManageGallery extends Component {
    constructor(props){
        super(props);
        this.state = {
            images: [],
            id: '',
            selectAll: false,
            selected : false,
            selected_count : true
        };
    }

    selectImage(event, obj) {
        let images = this.state.images;
        images[obj.index].selected = !images[obj.index].selected;
        this.setState({
            images: images,
        } ,() => {
            this.verifyMarked();
        });
    }

    verifyMarked(){
        this.mark_count = 0;
        this.state.images.map(image => {
            if(image.selected){
                this.mark_count += 1;

                this.setState({
                    selected: true,
                    selected_count: this.mark_count
                })
            }
        });
    }

    getImageId(e) {
        e.preventDefault();

        let marked = this.state.images.filter(image => {
            if (image.selected) {
                this.setState({
                    id: image.id
                })
            }
        });
    }

    deleteImages(e) {
        e.preventDefault();
        let marked = this.state.images.filter(image => {
            return image.selected
        });
        marked.map(image => {
            axios.post(`/photos/${image.id}`)
                .then(response => {
                    if(response.data.deleted){
                        this.setState({
                            images : this.state.images.filter(img => {
                                return img.id !== image.id
                            })
                        });
                    toastr.error('We hope you meant to do that !..', 'Image deleted !');
                }
            })
        })
    }

    componentDidMount(){
        axios.get('/photos')
            .then(response => {
                let images = response.data.map(image => {
                    return {
                        src : '/' + image.uri,
                        width : image.width,
                        height : image.height,
                        id :  image.id
                    }
                });

                this.setState({
                    images : images
                })
            })
    }

    render() {

        return (
            <div className="gallery">
                {this.state.selected ?
                    <Fragment>
                        <button
                            className="btn btn-danger deleteBtn"
                            onClick={this.deleteImages.bind(this)}
                        >
                            Delete {this.state.selected_count} Selected Photos
                        </button>
                        <div
                            className="btn btn-success updateBtn"
                            onClick={this.getImageId.bind(this)}
                        >
                            Update {this.state.selected_count} Selected Photos
                        </div>
                        {this.state.id ?
                            <Link to={`/photo/${this.state.id}`} className="updatePhotoLink btn btn-info">Update Photo Description</Link>
                            : null
                        }
                    </Fragment>
                : null
                }
                {this.state.images.length ?
                    <ReactGallery
                        photos={this.state.images}
                        onClick={this.selectImage.bind(this)}
                        ImageComponent={SelectedImage} />
                    :
                    <div className="no-images">
                        <h5 className="text-center">
                            You currently have no images in your photos gallery
                        </h5>
                    </div>
                }
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/components/ManageGallery.js